export const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const VITE_APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const VITE_SUPERTOKENS_APP_NAME = import.meta.env
  .VITE_SUPERTOKENS_APP_NAME;
export const VITE_COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
